// eslint-disable-next-line import/no-unresolved

function useLayout(onLayoutChange) {
  return {
    custom: true,
    horizontalScroll: true,
    onLayoutChange: onLayoutChange
  };
}
export default useLayout;